/**
 * 分页获取不在某个部门id下的企业用户
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IMemberList } from '@umu/umu-types';

export interface IUsersNotInDepartment {
    department_id: string;
    page: number;
    size: number;
}
export const getUsersNotInDepartment = (data: IUsersNotInDepartment) => {
    return fetchData(Api.GET_USERS_NOT_IN_DEPARTMENT, data).then((res: IListResponse<IMemberList>) => {
        return res.data;
    });
};
